$(function () {

    $(".js-mobile-popup").on("click", function () {
        if (isMobile()) {
            $.fancybox.open($(".filter-mobile"), {
                afterShow: function() {
                    $(".js-ajax-restaurant-fancy").removeClass("js-ajax-restaurant-fancy").addClass("js-ajax-restaurant")
                    ajaxRestaurant()
                }
            })
            return false
        }
    })

})